import React from 'react';
import { volumes } from '../data/volumes';
const everyVolume = ['16–22 Fence Card Sessions, one practice per page', '6–8 worksheets and a printable field card', 'The 90-Minute Practice Formula, with 60 and 75-minute versions', 'One session at three levels: Youth, Middle School, High School'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-chalk-light text-ink" data-id="element-513" data-mp="1p0w2e4jt3dg9">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-514" data-mp="1l15gae585li2">
        <div className="text-center" data-id="element-515" data-mp="1fzy7cbrcig9t">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-clay" data-id="element-516" data-mp="1fywm5egm8ded">Your whole season</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl text-ink sm:text-5xl" data-id="element-517" data-mp="1b1mxi111w5rl">
            Inside the pack: six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-518" data-mp="35fxk02u6anu7">
            The season in the order you coach it: set up the system, then one
            volume per event group, then meet season and the championship. Each
            volume stands on its own, so open the one your group needs this week.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-519" data-mp="2chbdst9zfkpq">
          {volumes.map(vol => <article key={vol.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-soft ${vol.flag ? 'border-clay ring-1 ring-clay' : 'border-chalk-dark'}`} data-id="element-520" data-mp="1xku3m5dj4c4r">
              <div className="flex items-center gap-2.5" data-id="element-521" data-mp="2v6rh1od1xr9u">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-base font-bold ${vol.badge}`} data-id="element-522" data-mp="2v8c8v67zew40">
                  {vol.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-widest text-ink-muted" data-id="element-523" data-mp="396ixdvr1jjr0">
                  Volume {vol.number}
                </span>
                {vol.flag && <span className="ml-auto rounded bg-clay px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-white" data-id="element-524" data-mp="3nspsgdoh8cee">
                    {vol.flag}
                  </span>}
              </div>
              <h3 className="mt-3 font-display text-2xl font-bold uppercase leading-tight text-ink" data-id="element-525" data-mp="3er8h18m0kyw1">{vol.title}</h3>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-clay-deep" data-id="element-526" data-mp="39sf3xhan39we">{vol.range}</p>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-527" data-mp="34vevizqbhv24">{vol.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-chalk-dark pt-4" data-id="element-528" data-mp="302lq09n0yioz">
                {vol.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-529" data-mp="2v4kb80wmt5jb">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-clay" data-id="element-530" data-mp="2r40e2xc261x6" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-6 rounded-2xl bg-navy px-5 py-5 text-chalk sm:px-7" data-id="element-531" data-mp="2h6m5tl0agjfy">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-hl" data-id="element-532" data-mp="wlyuynj8h4o0">In every volume</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-533" data-mp="11jqoflzj0yub">
            {everyVolume.map(item => <li key={item} className="flex gap-2 text-[13px] text-chalk/85" data-id="element-534" data-mp="16ik6lrprde0t">
                <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-hl" data-id="element-535" data-mp="1algr5nyuzk7e" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}